export default {"src":"/_next/static/media/master-card-light.1c12bf80.svg","height":48,"width":48};